import { fetchApi } from '../api/digitalVault';
import { parseResponse, parseTimeslots } from '../utils';
const getUserTimeslots = async (params, timezone, logger) => {
    const { timeslots } = await fetchApi(params, 'browse/imagevideo/timeslot', timezone && { 'X-Vault-Client-Timezone': timezone }, false, logger);
    const cursor = timeslots['@cursor'];
    return parseResponse(cursor, timeslots.timeslot, parseTimeslots, () => getUserTimeslots({ ...params, cursor }, timezone, logger));
};
export default getUserTimeslots;
